import React from 'react';
import Grid from '@material-ui/core/Grid';
import CasesDetailsTabPres from './CasesDetailsTabPres';
import CasesFormDetailContainer from 'src/ui/features/Cases/containers/CasesFormDetailContainer';
import CaseAdditionalInformationContainer from 'src/ui/features/Cases/containers/CaseAdditionalInformationContainer';
import CaseStatusTracker from 'src/ui/library/CaseStatusTracker/CaseStatusTrackerContainer';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import intl from 'react-intl-universal';
import CaseStatusFormDetailContainer from '../containers/CaseStatusFormDetailContainer';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

export default function ClientManagerCasesDetailsPres(props) {
  const {
    ticketNumber,
    applicant,
    currentCaseStatus,
    caseStages,
    receiptNumber,
    service,
    serviceCountry,
    targetDate,
  } = props.headerDetails;

  const {
    tab,
    caseMessagesCount,
    caseLineManagersCount,
    docCount,
    contactsCount,
    hasStatusForm,
    isAdditionalInfoSecExist,
    bpfStatusInfo,
  } = props;

  if (!applicant) return false;

  const showUscisLink = receiptNumber && serviceCountry === 'United States' && service === 'Immigration';

  return (
    <React.Fragment>
      <div className={fnShowNewDashboard() ? 'new-dashboard-cases-detail-header cases-details-header' : 'cases-details-header'}>
        <Grid container className="header-grid" spacing={0}>
          <Grid item xs={1} className="case-header-back-button">
            <HistoryDisplayContainer history={props.history} type={'white'} />
          </Grid>
          <Grid item xs={2} className="clientid-width-wrapper resized-grid">
            <div className="header-field nohover">
              <label className="field-label">{intl.get('cases.details.header.caseId')}</label>
              <span className="field-text" title={ticketNumber}>
                {ticketNumber}
              </span>
            </div>
          </Grid>
          <Grid item xs={2} className="resized-grid">
            <div className="employeeapplicant-wrapper">
              <div className="header-field nohover">
                <label className="field-label">{intl.get('cases.details.header.employee')}</label>
                <span className="field-text" title={applicant.fullName ? `${applicant.fullName}` : ''}>
                  {applicant.fullName ? `${applicant.fullName}` : ''}
                </span>
              </div>
            </div>
          </Grid>
          <Grid item xs={2} className="resized-grid">
            <div className="header-field nohover">
              <label className="field-label">{intl.get('cases.details.header.service')}</label>
              <span className="field-text" title={service}>
                {service}
              </span>
            </div>
          </Grid>
          <Grid item xs={2} className="resized-grid2">
            <div className="header-field nohover">
              <label className="field-label">{intl.get('cases.details.header.serviceCountry')}</label>
              <span className="field-text" title={serviceCountry}>
                {serviceCountry}
              </span>
            </div>
          </Grid>
          <Grid item xs={2} className="resized-grid">
            <div className={'casestatus-wrapper'}>
              <div className="header-field nohover">
                <label className="field-label">{intl.get('cases.details.header.status')}</label>
                <span className="field-text" title={currentCaseStatus}>
                  {currentCaseStatus}
                </span>
              </div>
            </div>
          </Grid>
          <Grid item xs={2} className="resized-grid">
            <div className={'casestatus-wrapper'}>
              <div className="header-field nohover">
                <label className="field-label">{intl.get('cases.details.header.targetCompletionDate')}</label>
                <span className="field-text" title={targetDate}>
                  {targetDate}
                </span>
              </div>
            </div>
          </Grid>
          {showUscisLink && (
            <Grid item xs={2}>
              <div className="header-field nohover">
                <label>{intl.get('cases.details.header.uscisStatus')}</label>
                <form id="uscis" action="https://egov.uscis.gov/casestatus/mycasestatus.do" method="post" target="_blank">
                  <input type="hidden" name="appReceiptNum" id="appReceiptNum" value={receiptNumber} />
                  <input type="hidden" name="initCaseSearch" id="initCaseSearch" value="CHECK STATUS" />
                  <input type="submit" value={receiptNumber} className="field-text" />
                </form>
              </div>
            </Grid>
          )}
        </Grid>
      </div>

      {caseStages && caseStages.length > 0 && <CaseStatusTracker caseStages={caseStages} />}

      <Grid container className={fnShowNewDashboard() ? 'new-cases-details cases-details-content' : 'cases-details-content'} spacing={0}>
        <Grid item xs={12} className="cases-details-tabs">
          <CasesDetailsTabPres
            {...props}
            caseMessagesCount={caseMessagesCount}
            docCount={docCount}
            contactsCount={contactsCount}
            caseLineManagersCount={caseLineManagersCount}
            tab={tab}
            hasStatusForm={hasStatusForm}
            isAdditionalInfoSecExist={isAdditionalInfoSecExist}
            isStatusFormPresent={bpfStatusInfo && bpfStatusInfo.success}
            onChange={props.handleTabSelect}
          />
        </Grid>
        <Grid item xs={12} className="cases-details-body">
          <CasesFormDetailContainer isActive={tab === 0} {...props} />
          <CaseStatusFormDetailContainer isActive={tab === 1} {...props} />
          <CaseAdditionalInformationContainer isActive={tab === 2} {...props} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
